// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Note Detail Component */
note-detail {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.note-detail-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.note-detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 2rem;
  height: 4rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  background-color: transparent;
}

.note-detail-header.mobile {
  padding: 0.75rem 1rem;
  height: 3.5rem;
  background-color: var(--bg-main);
}

.dark .note-detail-header {
  border-bottom-color: rgba(255, 255, 255, 0.05);
}

.note-detail-back-btn {
  display: none;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border: none;
  border-radius: 0.5rem;
  background: transparent;
  color: var(--text-primary);
  cursor: pointer;
}

.note-detail-header.mobile .note-detail-back-btn {
  display: flex;
}

.note-detail-last-edited {
  font-size: 0.75rem;
  color: var(--text-muted);
  font-weight: 500;
}

.note-detail-actions {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.note-detail-action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
  transition: all var(--transition-normal);
}

.note-detail-action-btn:hover {
  background-color: rgba(0, 0, 0, 0.05);
  color: var(--text-primary);
}

.dark .note-detail-action-btn:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.note-detail-action-btn.delete:hover {
  background-color: rgba(220, 38, 38, 0.1);
  color: var(--color-error);
}

.note-detail-content {
  flex: 1;
  overflow-y: auto;
  padding: 1.5rem 3rem;
}

.note-detail-content.mobile {
  padding: 1rem 1.25rem;
}

.note-detail-title {
  width: 100%;
  margin: 0 0 1rem 0;
  font-size: 2rem;
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1.3;
  word-wrap: break-word;
}

.note-detail-title.mobile {
  font-size: 1.5rem;
}

.note-detail-body {
  width: 100%;
  margin: 0;
  font-size: 1rem;
  color: var(--text-muted);
  line-height: 1.7;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.note-detail-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  color: var(--text-muted);
  padding: 2rem;
}

.note-detail-empty-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
  opacity: 0.3;
}

.note-detail-empty-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: var(--text-primary);
}

.note-detail-empty-text {
  font-size: 0.875rem;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/note-detail.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,4CAA4C;EAC5C,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX","sourcesContent":["/* Note Detail Component */\nnote-detail {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.note-detail-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.note-detail-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 2rem;\n  height: 4rem;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n  background-color: transparent;\n}\n\n.note-detail-header.mobile {\n  padding: 0.75rem 1rem;\n  height: 3.5rem;\n  background-color: var(--bg-main);\n}\n\n.dark .note-detail-header {\n  border-bottom-color: rgba(255, 255, 255, 0.05);\n}\n\n.note-detail-back-btn {\n  display: none;\n  align-items: center;\n  justify-content: center;\n  width: 2.5rem;\n  height: 2.5rem;\n  border: none;\n  border-radius: 0.5rem;\n  background: transparent;\n  color: var(--text-primary);\n  cursor: pointer;\n}\n\n.note-detail-header.mobile .note-detail-back-btn {\n  display: flex;\n}\n\n.note-detail-last-edited {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n  font-weight: 500;\n}\n\n.note-detail-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.note-detail-action-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.25rem;\n  height: 2.25rem;\n  border: none;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: all var(--transition-normal);\n}\n\n.note-detail-action-btn:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n  color: var(--text-primary);\n}\n\n.dark .note-detail-action-btn:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.note-detail-action-btn.delete:hover {\n  background-color: rgba(220, 38, 38, 0.1);\n  color: var(--color-error);\n}\n\n.note-detail-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1.5rem 3rem;\n}\n\n.note-detail-content.mobile {\n  padding: 1rem 1.25rem;\n}\n\n.note-detail-title {\n  width: 100%;\n  margin: 0 0 1rem 0;\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  line-height: 1.3;\n  word-wrap: break-word;\n}\n\n.note-detail-title.mobile {\n  font-size: 1.5rem;\n}\n\n.note-detail-body {\n  width: 100%;\n  margin: 0;\n  font-size: 1rem;\n  color: var(--text-muted);\n  line-height: 1.7;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n\n.note-detail-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  text-align: center;\n  color: var(--text-muted);\n  padding: 2rem;\n}\n\n.note-detail-empty-icon {\n  font-size: 4rem;\n  margin-bottom: 1rem;\n  opacity: 0.3;\n}\n\n.note-detail-empty-title {\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin: 0 0 0.5rem 0;\n  color: var(--text-primary);\n}\n\n.note-detail-empty-text {\n  font-size: 0.875rem;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
